import { RootState } from "../../store";

export const isFilterChangedManuallySelector = (state: RootState): boolean =>
  state.filters.filterChangedManually;
